<div class="container styleGuide">
    <div class="row">
        <div class="col-md-12 header">
            <h1>CCR Desktop StyleGuide</h1>
        </div>
    </div>

    <div class="row">
        <div class="col-md-10 offset-md-1">
            <div class="row">
                <div class="col-md-12">
                    <f-data-card>
                        <h2>FONT</h2>
                        <p> <strong>Font-Family:</strong> FS Thrive Elliot; </p>

                        <h3>Typography</h3>

                        <h4>H1</h4>
                        
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><h1>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </h1></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 48px;<br>
                                font-weight: 400;<br>
                                line-height: 1.2<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 
                        <h4>H2</h4>        
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </h2></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 36px;<br>
                                font-weight: 400;<br>
                                line-height: 1.2<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 
                        <h4>h3</h4>
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><h3>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </h3></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 32px;<br>
                                font-weight: 400;<br>
                                line-height: 1.2<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 
                        <h4>H4</h4>   
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><h4>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </h4></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 22px;<br>
                                font-weight: 400;<br>
                                line-height: 1.5<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 
                        <h4>H5</h4>   
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><h5>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </h5></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 20px;<br>
                                font-weight: 400;<br>
                                line-height: 1.5<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 
                        <h4>H6</h4>   
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><h6>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </h6></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 18px;<br>
                                font-weight: 400;<br>
                                line-height: 1.5<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 

                        <h4>Body</h4>   
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </p></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 16px;<br>
                                font-weight: 400;<br>
                                line-height: 1.5<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 

                        <h4>Legal</h4>   
                        <table >
                            <tr>
                              <th>Component</th>
                              <th>Property</th>
                            </tr>
                            <tr>
                              <td><p class="legalTxt">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </p></td>
                              <td>
                                font-family: FS Thrive Elliot; <br>
                                font-size: 13px;<br>
                                font-weight: 400;<br>
                                line-height: 1.5<br>
                                letter-spacing: 0px;<br>
                                text-align: left;<br>
                                </td>
                            </tr>
                            
                        </table> 





                    </f-data-card>

                <f-data-card>
                    <h3>CCR Primary Colors</h3>
                    <div class="ccr-colors"> 
                        <div class="colorbox defaultBlue">#276DE2</div>
                        <div class="colorbox buttonActive">#165BCF</div>
                        <div class="colorbox buttonDisable">#949494</div>
                        <div class="colorbox error">#EE3F2F</div>
                        <div class="colorbox errorTxt">#C61A1A</div>
                        <div class="colorbox textGray">#282828</div>
                        <div class="colorbox borderGray">#767676</div>
                    </div>


                   
                </f-data-card>    
                </div>
            </div>
        

        </div>
    </div>


</div>